import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    delay: { type: Number, default: 300 },
  };

  connect() {
    this.timeout = null;
  }

  disconnect() {
    this.clearTimeout();
  }

  input() {
    this.clearTimeout();

    // Set debounced timeout
    this.timeout = setTimeout(() => {
      this.submitForm();
    }, this.delayValue);
  }

  submitOnEnter(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      this.clearTimeout();
      this.submitForm();
    }
  }

  submitForm() {
    if (!navigator.onLine) {
      location.reload();
      return;
    }

    this.element.requestSubmit();
  }

  clearTimeout() {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
  }
}
